import React from 'react'
import UploadCloudIcon from '../../../components/common/icons/UploadIcon'

function FileUpload({
  label,
  required,
  name,
  value,
  fileName,
  onChange,
  onRemove,
}) {
  return (
    <div className="w-full bg-gray-100 border border-gray-300 rounded-lg p-6 flex flex-col items-center justify-center">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      {fileName ? (
        <div className="w-full flex items-center justify-between bg-white border border-gray-300 rounded-md px-4 py-3 mb-3">
          <div className="flex items-center gap-2 min-w-0">
            <svg
              className="w-5 h-5 text-blue-600 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <span className="text-sm text-gray-800 truncate">{fileName}</span>
          </div>
          <div className="flex items-center gap-2 shrink-0 ml-3">
            <button
              type="button"
              onClick={() => {
                const input = document.getElementById(`file-input-${name}`)
                if (input) input.click()
              }}
              className="text-xs text-blue-600 hover:text-blue-800 font-medium underline"
            >
              Replace
            </button>
            <button
              type="button"
              onClick={onRemove}
              className="text-xs text-red-600 hover:text-red-800 font-medium underline"
            >
              Remove
            </button>
          </div>
        </div>
      ) : (
        <>
          <p className="text-gray-600 text-sm mb-3">
            upload <span className="font-medium">.pdf, .doc, .docx</span> files
          </p>
          <label className="bg-darkBlue hover:bg-primaryBlue text-white text-sm font-medium py-2 px-4  cursor-pointer rounded-xs  flex items-center gap-2">
            <UploadCloudIcon className="w-4 h-4" />
            Browse &amp; Upload
            <input
              type="file"
              id={`file-input-${name}`}
              name={name}
              value={value ?? undefined}
              onChange={onChange}
              className="hidden"
            />
          </label>
        </>
      )}

      {/* Hidden input always present for replace functionality */}
      {fileName && (
        <input
          type="file"
          id={`file-input-${name}`}
          name={name}
          className="hidden"
          onChange={onChange}
        />
      )}
    </div>
  )
}

export default FileUpload
